import SinglePublicationMetaContent from './SinglePublicationMetaContent';
export default SinglePublicationMetaContent;
